export default __webpack_public_path__ + "static/media/arrowDown.4ecef12b.svg";